import RolesMaster from "pages/config/RolesMaster";
import React from "react";
import { Navigate } from "react-router-dom";
import PathConstants from "./pathConstants";
import {
  JalkalRoute,
  OfficialsRoute,
  ProtectedRoute,
  SharedProtectedRoute,
} from "./ProtectedRoutes";
const CollectionsList = React.lazy(() =>
  import("pages/reports/CollectionsList")
);
const GISModule = React.lazy(() => import("pages/properties/list/GIS"));
const WhatsAppPayment = React.lazy(() =>
  import("pages/payments/dashboard/WhatsAppPayment")
);
const Dashboard = React.lazy(() => import("pages/reports/Dashboard"));
const GISReport = React.lazy(() => import("pages/reports/GISReport"));
const DebitCreditNote = React.lazy(() =>
  import("pages/reports/DebitCreditNote")
);
const ArrearsCorrection = React.lazy(() =>
  import("pages/properties/edit/ArrearsCorrection")
);
const EditedProperties = React.lazy(() =>
  import("pages/properties/list/EditedProperties")
);
const DiscountMaster = React.lazy(() => import("pages/config/DiscountMaster"));
const DefaultersList = React.lazy(() => import("pages/reports/DefaultersList"));
const PostingDashboard = React.lazy(() =>
  import("pages/payments/dashboard/PostingDashboard")
);
const OldProperties = React.lazy(() =>
  import("pages/properties/old/OldProperties")
);
const ARVList = React.lazy(() => import("pages/reports/ARVList"));
const CollectionsReport = React.lazy(() =>
  import("pages/reports/CollectionsReport")
);
const Ledger = React.lazy(() => import("pages/home/Ledger"));
const HomePage = React.lazy(() => import("pages/home/HomePage"));
const Login = React.lazy(() => import("pages/login/Login"));
const SearchProperty = React.lazy(() => import("pages/home/SearchProperty"));
const JalkalDashboard = React.lazy(() =>
  import("pages/jalkal/JalkalDashboard")
);
const ObjectionsDashboard = React.lazy(() =>
  import("pages/officials/ObjectionsDashboard")
);
const ObjectionStatus = React.lazy(() =>
  import("pages/objections/ObjectionStatus")
);
const PayOfflineTax = React.lazy(() =>
  import("pages/payments/payment.details/PayOfflineTax")
);
const PayOnlineTax = React.lazy(() =>
  import("pages/payments/payment.details/PayOnlineTax")
);
const Notices = React.lazy(() => import("pages/notices/Notices"));
const SelfAssessment = React.lazy(() =>
  import("pages/self-assessment/SelfAssessment")
);
const SelfAssessmentCitizen = React.lazy(() =>
  import("pages/self-assessment/SelfAssessmentCitizen")
);
const SelfAssessmentNigam = React.lazy(() =>
  import("pages/self-assessment/SelfAssessmentNigam")
);
const DemandsDashboard = React.lazy(() =>
  import("pages/reports/DemandsDashboard")
);
const OnlineTransactions = React.lazy(() =>
  import("pages/payments/dashboard/OnlineTransactions")
);
const OnlineTransactionsV2 = React.lazy(() =>
  import("pages/payments/dashboard/OnlineTransactionsV2")
);
const Transactions = React.lazy(() =>
  import("pages/payments/dashboard/Transactions")
);
const ArchivedTransactions = React.lazy(() =>
  import("pages/payments/dashboard/ArchivedTransactions")
);

const OldPayments = React.lazy(() =>
  import("pages/payments/dashboard/OldPayments")
);
const OfficialsMaster = React.lazy(() =>
  import("pages/config/OfficialsMaster")
);
const OperatorsMaster = React.lazy(() =>
  import("pages/config/OperatorsMaster")
);
const WardMaster = React.lazy(() => import("pages/config/WardMaster"));
const ZoneMaster = React.lazy(() => import("pages/config/ZoneMaster"));
const MohallaMaster = React.lazy(() => import("pages/config/MohallaMaster"));
const Properties = React.lazy(() =>
  import("pages/properties/list/PropertyList")
);
const AddProperty = React.lazy(() =>
  import("pages/properties/add/AddProperty")
);
const EditProperty = React.lazy(() =>
  import("pages/properties/edit/EditProperty")
);
const ARVCalculations = React.lazy(() => import("pages/home/ARVCalculations"));
const DownloadPaymentReceipt = React.lazy(() =>
  import("pages/payments/DownloadPaymentReceipt")
);
const AdminUtility = React.lazy(() => import("pages/admin/AdminUtility"));
const PushDataToENagarSewa = React.lazy(() =>
  import("pages/admin/PushDataToENagarSewa")
);
const MutationDashboard = React.lazy(() =>
  import("pages/mutations/MutationDashboard")
);
const DemandDashboard = React.lazy(() =>
  import("pages/officials/DemandDashboard")
);
const NEFTTransactions = React.lazy(() =>
  import("pages/payments/dashboard/NEFTTransactions")
);
const PostTaxPayment = React.lazy(() =>
  import("pages/payments/payment.details/PostTaxPayment")
);
const SplitProperty = React.lazy(() =>
  import("pages/properties/edit/SplitProperty")
);
const Logs = React.lazy(() => import("pages/logs/Logs"));

const isMaintenanceMode = true;

const routes = [
  {
    path: PathConstants.SEARCH_PROPERTY,
    element: isMaintenanceMode ? (
      <Navigate to={PathConstants.UNDER_MAINTENANCE} />
    ) : (
      <SearchProperty />
    ),
  },
  {
    path: PathConstants.LOGIN,
    element: <Login />,
  },

  {
    path: PathConstants.LEDGER,
    element: <Ledger />,
  },

  { path: PathConstants.LEDGER_QUERY, element: <Ledger /> },
  {
    path: PathConstants.PROPERTY_SPLIT,
    element: <SplitProperty />,
  },
  {
    path: PathConstants.ARV_CALCULATIONS,
    element: isMaintenanceMode ? (
      <Navigate to={PathConstants.UNDER_MAINTENANCE} />
    ) : (
      <ARVCalculations />
    ),
  },

  {
    path: PathConstants.PAY_ONLINE_TAX,
    children: [
      {
        path: ":propertyUniqueId",
        element: isMaintenanceMode ? (
          <Navigate to={PathConstants.UNDER_MAINTENANCE} />
        ) : (
          <PayOnlineTax />
        ),
      },
    ],
  },

  {
    path: PathConstants.OPERATORS,
    children: [
      {
        path: PathConstants.OPERATORS_SEARCH,
        element: (
          <ProtectedRoute>
            <SearchProperty />
          </ProtectedRoute>
        ),
      },
      {
        path: PathConstants.OPERATORS_ARV_CALCULATIONS,
        element: (
          <ProtectedRoute>
            <ARVCalculations />
          </ProtectedRoute>
        ),
      },
    ],
  },

  {
    path: PathConstants.SELF_ASSESSMENT,
    children: [
      {
        index: true,
        element: <SelfAssessment />,
      },
      {
        path: PathConstants.SELF_ASSESSMENT_NIGAM,
        element: <SelfAssessmentNigam />,
      },
      {
        path: PathConstants.SELF_ASSESSMENT_STATUS,
        element: <SelfAssessmentCitizen />,
      },
    ],
  },

  {
    path: PathConstants.OBJECTION_STATUS,
    element: isMaintenanceMode ? (
      <Navigate to={PathConstants.UNDER_MAINTENANCE} />
    ) : (
      <ObjectionStatus />
    ),
  },

  {
    path: PathConstants.UPLOAD_OBJECTION,
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },

  {
    path: PathConstants.PAYMENT_RECEIPT,
    element: isMaintenanceMode ? (
      <Navigate to={PathConstants.UNDER_MAINTENANCE} />
    ) : (
      <DownloadPaymentReceipt />
    ),
  },

  {
    path: PathConstants.PAY_OFFLINE_TAX,
    children: [
      {
        path: ":propertyUniqueId",
        element: (
          <ProtectedRoute>
            <PayOfflineTax />
          </ProtectedRoute>
        ),
      },
    ],
  },

  {
    path: PathConstants.PAY_NEFT_TAX,
    children: [
      {
        path: ":propertyUniqueId",
        element: (
          <OfficialsRoute>
            <PostTaxPayment />
          </OfficialsRoute>
        ),
      },
    ],
  },
  {
    path: PathConstants.TRANSACTIONS_NEFT,
    element: (
      <SharedProtectedRoute>
        <NEFTTransactions />
      </SharedProtectedRoute>
    ),
  },
  {
    path: PathConstants.OLD_TRANSACTIONS,
    element: (
      <SharedProtectedRoute>
        <OldPayments />
      </SharedProtectedRoute>
    ),
  },
  {
    path: PathConstants.TRANSACTIONS_OFFLINE,
    element: (
      <SharedProtectedRoute>
        <Transactions />
      </SharedProtectedRoute>
    ),
  },

  {
    path: PathConstants.TRANSACTIONS_POSTING_NIGAM,
    element: (
      <SharedProtectedRoute>
        <PostingDashboard />
      </SharedProtectedRoute>
    ),
  },
  {
    path: PathConstants.ARCHIVED_TRANSACTIONS,
    element: (
      <SharedProtectedRoute>
        <ArchivedTransactions />
      </SharedProtectedRoute>
    ),
  },
  {
    path: PathConstants.ALL_ONLINE_TRANSACTIONS,
    element: (
      <OfficialsRoute>
        <OnlineTransactionsV2 />
      </OfficialsRoute>
    ),
  },
  {
    path: PathConstants.WHATSAPP_PAYMENT,
    element: (
      <OfficialsRoute>
        <WhatsAppPayment />
      </OfficialsRoute>
    ),
  },
  {
    path: PathConstants.ADMIN_ONLINE_TRANSACTIONS,
    element: (
      <OfficialsRoute>
        <OnlineTransactions />
      </OfficialsRoute>
    ),
  },

  {
    path: PathConstants.DASHBOARD_OBJECTIONS,
    element: (
      <SharedProtectedRoute>
        <ObjectionsDashboard />
      </SharedProtectedRoute>
    ),
  },

  {
    path: PathConstants.JALKAL_DASHBOARD,
    element: (
      <JalkalRoute>
        <JalkalDashboard />
      </JalkalRoute>
    ),
  },

  {
    path: PathConstants.DEMAND_DASHBOARD,
    element: (
      <OfficialsRoute>
        <DemandDashboard />,
      </OfficialsRoute>
    ),
  },

  {
    path: PathConstants.LOGS,
    element: <Logs />,
  },

  /*----------  Reports Routes  ----------*/

  {
    children: [
      {
        path: PathConstants.REPORT_DASHBOARD,
        element: (
          <OfficialsRoute>
            <Dashboard />,
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.DEMAND_REPORTS,
        element: (
          <OfficialsRoute>
            <DemandsDashboard />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.DEFAULTERS_LIST,
        element: (
          <OfficialsRoute>
            <DefaultersList />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.ARV_LIST,
        element: (
          <OfficialsRoute>
            <ARVList />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.COLLECTION_REPORT,
        element: (
          <OfficialsRoute>
            <CollectionsReport />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.COLLECTION_LIST_REPORT,
        element: (
          <SharedProtectedRoute>
            <CollectionsList />
          </SharedProtectedRoute>
        ),
      },
      {
        path: PathConstants.DEMAND_REPORTS,
        element: (
          <OfficialsRoute>
            <DemandsDashboard />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.REPORT_GIS,
        element: (
          <OfficialsRoute>
            <GISReport />
          </OfficialsRoute>
        ),
      },
    ],
  },

  /*----------  Master Routes  ----------*/

  {
    children: [
      {
        path: PathConstants.CONFIG_OPERATORS,
        element: (
          <OfficialsRoute>
            <OperatorsMaster />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.CONFIG_OFFICIALS,
        element: (
          <OfficialsRoute>
            <OfficialsMaster />
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.CONFIG_WARDS,
        element: (
          <OfficialsRoute>
            <WardMaster />
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.CONFIG_ZONES,
        element: (
          <OfficialsRoute>
            <ZoneMaster />
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.CONFIG_MOHALLAS,
        element: (
          <OfficialsRoute>
            <MohallaMaster />
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.CONFIG_DISCOUNTS,
        element: (
          <OfficialsRoute>
            <DiscountMaster />
          </OfficialsRoute>
        ),
      },

      {
        path: PathConstants.CONFIG_ROLES,
        element: (
          <OfficialsRoute>
            <RolesMaster />
          </OfficialsRoute>
        ),
      },
    ],
  },

  /*----------  Property Routes  ----------*/

  {
    children: [
      {
        path: PathConstants.PROPERTIES,
        element: (
          <OfficialsRoute>
            <Properties />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.EDITED_PROPERTIES,
        element: (
          <OfficialsRoute>
            <EditedProperties />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.ADD_PROPERTY,
        element: (
          <OfficialsRoute>
            <AddProperty />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.EDIT_PROPERTY,
        element: (
          <OfficialsRoute>
            <EditProperty />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.DEBIT_CREDIT_NOTE,
        element: (
          <OfficialsRoute>
            <DebitCreditNote />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.ARREARS_FORM,
        element: (
          <OfficialsRoute>
            <ArrearsCorrection />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.OLD_PROPERTIES,
        element: (
          <OfficialsRoute>
            <OldProperties />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.PROPERTY_NOTICES,
        element: (
          <OfficialsRoute>
            <Notices />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.GIS_MODULE,
        element: (
          <OfficialsRoute>
            <GISModule />
          </OfficialsRoute>
        ),
      },
      {
        path: PathConstants.MUTATIONS,
        element: (
          <OfficialsRoute>
            <MutationDashboard />
          </OfficialsRoute>
        ),
      },
    ],
  },

  /* ---------  Admin Utility Routes ----------*/
  {
    path: PathConstants.ADMIN_UTILITY,
    element: (
      <OfficialsRoute>
        <AdminUtility />
      </OfficialsRoute>
    ),
  },
  {
    path: PathConstants.PUSH_DATA,
    element: (
      <OfficialsRoute>
        <PushDataToENagarSewa />
      </OfficialsRoute>
    ),
  },
];

export default routes;
